var _radialGradient, _linearGradient, _filter;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    cy: 57.021,
    cx: 57.388,
    r: 264.58
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9dd5f6"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#98d3f5"
    },
    offset: 0.0711
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#89cef3"
    },
    offset: 0.1575
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#70c6ef"
    },
    offset: 0.2516
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#4ebbea"
    },
    offset: 0.3514
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#23ade3"
    },
    offset: 0.4546
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0da6e0"
    },
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2e77bc"
    },
    offset: 1
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    cy: 87.817,
    cx: 74.15,
    gradientTransform: "matrix(.94037 0 0 .23184 15.006 103.16)",
    r: 68.347
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y2: 130.85,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 243.69,
    gradientTransform: "translate(-1.1976 3.1138)",
    y1: 130.85,
    x1: -4.4952
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 131.09,
    spreadMethod: "reflect",
    gradientUnits: "userSpaceOnUse",
    x2: 449.94,
    gradientTransform: "translate(1.1591 2.9438) scale(.99222)",
    y1: 131.09,
    x1: 120.68
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    offset: 1
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9545
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.38 -.63) scale(.90052)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeLinejoin: "round",
      strokeOpacity: 0.5291,
      strokeDashoffset: 9,
      stroke: "#000",
      strokeLinecap: "round",
      fill: "url(#b)"
    },
    rx: 11.483,
    ry: 11.403,
    height: 143.71,
    width: 247.19,
    y: 62.106,
    x: -5.1928
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#c)"
    },
    rx: 4.9323,
    ry: 4.9611,
    height: 91.736,
    width: 244.31,
    y: 88.094,
    x: -3.7557
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d)"
    },
    d: "M69.063 116.4h37.502l5.9688 6.1941 6.3067-6.1941h46.554l5.0042 3.1455 2.4306-3.1455h12.907l-7.6581 14.866 7.6581 13.064-13.051.0922-2.716-2.5813-3.5744 2.4192-83.593-.3018-3.8302-1.9292-5.0674 1.8971-12.951-.0467 8.1086-27.479z",
    transform: "translate(-75.214 -67.199) scale(1.5384)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2"
    },
    d: "m70.168 112.2-16.232 37.073h19.438l2.4047-5.9116h5.5108l2.4047 5.9116h21.392v-4.5088l1.9037 4.5088h11.072l1.9037-4.609v4.609h44.487l5.4106-5.7613 5.0599 5.7613 22.845.05-16.282-18.486 16.282-18.637h-22.494l-5.2603 5.6611-4.9096-5.6611h-48.395l-4.1582 9.5688-4.2584-9.5688h-19.388v4.3586L86.7504 112.2h-16.583zm3.7574 5.2603h9.4686l10.771 25.149v-25.149h10.37l8.3163 18.035 7.665-18.035h10.32v26.602h-6.2623l-.0501-20.841-9.168 20.841h-5.611l-9.2181-20.841v20.841h-12.925l-2.4548-5.9617H71.921l-2.4548 5.9617h-6.9136l11.372-26.602zm62.673 0h25.55l7.8153 8.7171 8.0658-8.7171h7.8153l-11.873 13.376 11.873 13.226h-8.166l-7.8153-8.8173-8.1159 8.8173h-25.149v-26.602zm-58.064 4.5088-4.3586 10.621h8.7171l-4.3586-10.621zm64.376 1.002v4.8596h13.927v5.4106h-13.927v5.3104h15.631l7.2643-7.8153-6.9637-7.7652h-15.931z",
    transform: "translate(-75.214 -67.199) scale(1.5384)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeLinejoin: "round",
      strokeOpacity: 0.5291,
      strokeDashoffset: 9,
      filter: "url(#e)",
      stroke: "#000",
      strokeLinecap: "round",
      fill: "url(#radialGradient3293)"
    },
    rx: 11.483,
    ry: 11.403,
    height: 143.71,
    width: 247.19,
    y: 62.106,
    x: -5.1928
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.8bd724a601120357704b02ab77cf143f.svg";
export { ForwardRef as ReactComponent };